import CalendarQuestion from '@/ui/components/CalendarQuestion/CalendarQuestion';

export default CalendarQuestion;
